import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { GlobalLoaderService } from './global-loader.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalLoaderInterceptor } from '../interceptors/global-loader.interceptor';
import { FirebaseService } from './firebase.service';
import { MainShellService } from './main-shell.service';
import { AgentService } from './agent.service';
import { ApplicantService } from './applicant.service';
import { PatentService } from './patent.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    AuthService,
    UserService,
    FirebaseService,
    GlobalLoaderService,
    MainShellService,
    AgentService,
    ApplicantService,
    PatentService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalLoaderInterceptor,
      multi: true,
    },
  ]
})
export class ServicesModule { }
